export default __webpack_public_path__ + "static/media/pin-old-district-office.208cece6.png";